import { Helpers } from '../../helpers';
import { IChangeRequestStatus } from '../../interfaces/ichange-request-status';
import { ChangeRequest } from '../change-request';

export class ChangeRequestStatusBase {
  ChangeRequestStatusId: number;
  Name: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ChangeRequests_ChangeRequestStatus?: Array<ChangeRequest> | null;

  constructor(item?: IChangeRequestStatus) {
    if (item) {

      this.ChangeRequestStatusId = item.ChangeRequestStatusId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ChangeRequests_ChangeRequestStatus = Helpers.createClassArray(ChangeRequest, item.ChangeRequests_ChangeRequestStatus);
    }
  }
}